import type { CSSProperties } from 'react';
import arrowRaw from '@/assets/join/job-arrow.svg?raw';
import styles from './index.module.scss';

export interface JobArrowProps {
  className?: string;
  color?: string;
}

export default function JobArrow({ className, color }: JobArrowProps) {
  const style: CSSProperties | undefined = color ? { color } : undefined;

  return (
    <span
      className={[styles.root, className].filter(Boolean).join(' ')}
      style={style}
      aria-hidden
      dangerouslySetInnerHTML={{ __html: arrowRaw }}
    />
  );
}
